import * as actionTypes from "../ActionTypes";

const initialState = {
  loading: false,
  services: [],
  error: null,
};

export default function servicesReducer(state = initialState, action) {
  switch (action.type) {
    // 🔹 START REQUEST
    case actionTypes.SAVE_SERVICE_REQUEST:
        case actionTypes.SAVE_CAMPUS_TIME_REQUEST:
            case actionTypes.SAVE_SERVICE_GALLERY_REQUEST:
                case actionTypes.DELETE_SERVICE_REQUEST:
                    case actionTypes.UPDATE_SERVICE_REQUEST:
                        case actionTypes.UPDATE_CAMPUS_TIME_REQUEST:
                        case actionTypes.UPDATE_SERVICE_GALLERY_REQUEST:
                          case actionTypes.DELETE_SERVICE_GALLERY_REQUEST:
                            case actionTypes.DELETE_CAMPUS_TIME_REQUEST:

      return { ...state, loading: true, error: null };

    // 🔹 SAVE SUCCESS
    case actionTypes.SAVE_SERVICE_SUCCESS:
        case actionTypes.SAVE_CAMPUS_TIME_SUCCESS:
            case actionTypes.SAVE_SERVICE_GALLERY_SUCCESS:

      return {
        ...state,
        loading: false,
        services: [...state.services, action.payload],
      };
      case actionTypes.DELETE_SERVICE_SUCCESS:
        return {
          ...state,
          loading: false,
          services: state.services.filter(
            (service) => service.serviceObjId !== action.payload.serviceObjId
          ),
        };
        case actionTypes.UPDATE_SERVICE_SUCCESS:
            case actionTypes.UPDATE_CAMPUS_TIME_SUCCESS:
            case actionTypes.UPDATE_SERVICE_GALLERY_SUCCESS:
              return {
                ...state,
                loading: false,
                services: state.services.map((service) =>
                  service.serviceObjId === action.payload.serviceObjId
                    ? { ...service, ...action.payload }
                    : service
                ),
              };
              case actionTypes.DELETE_SERVICE_GALLERY_SUCCESS:
                                return {
                  ...state,
                  loading: false,
                  services: state.services.map((service) =>
                    service.serviceObjId === action.payload.serviceObjId
                      ? {
                          ...service,
                          servicegallery: service.servicegallery?.filter(
                            (g) => g._id !== action.payload.serviceGalleryObjId
                          ),
                        }
                      : service
                  ),
                };
                case actionTypes.DELETE_CAMPUS_TIME_SUCCESS:
                  return {
                    ...state,
                    loading: false,
                    services: state.services.map((service) =>
                      service.serviceObjId === action.payload.serviceObjId
                        ? {
                            ...service,
                            campusandtime: service.campusandtime?.filter(
                              (item) => item._id !== action.payload.campusandtimeObjId
                            ),
                          }
                        : service
                    ),
                  };

    // 🔹 SAVE FAILURE
    case actionTypes.SAVE_SERVICE_FAILURE:
        case actionTypes.SAVE_CAMPUS_TIME_FAILURE:
            case actionTypes.SAVE_SERVICE_GALLERY_FAILURE:
                case actionTypes.DELETE_SERVICE_FAILURE:
                    case actionTypes.UPDATE_SERVICE_FAILURE:
                        case actionTypes.UPDATE_CAMPUS_TIME_FAILURE:
                        case actionTypes.UPDATE_SERVICE_GALLERY_FAILURE:
                          case actionTypes.DELETE_SERVICE_GALLERY_FAILURE:
                            case actionTypes.DELETE_CAMPUS_TIME_FAILURE:

      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
